import apiConfig from '../config/api.config';

export const API = {
  // URL completa de la API
  DEV: apiConfig.apiUrl,
  
  // URL base (para links externos)
  BASE_URL: apiConfig.baseUrl,
  
  // Helper para construir endpoints
  endpoint: apiConfig.endpoint,
  
  // Helper para generador
  generatorUrl: apiConfig.generatorUrl,
  
  // Info del entorno
  isProduction: apiConfig.isProduction,
  isDevelopment: apiConfig.isDevelopment,
};
